import "./App.css";
import { RouterProvider } from "react-router-dom";
import { ChakraProvider, extendTheme } from "@chakra-ui/react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { router } from "./routes";

const theme = extendTheme({
  semanticTokens: {
    colors: {
      error: "red.200",
      success: "green.200",
      primary: {
        default: "red.200",
        _dark: "red.300",
      },
      secondary: {
        default: "red.200",
        _dark: "red.300",
      },
    },
  },
  components: {
    Link: {
      baseStyle: {
        //textDecoration: "underline",
      },
    },
  },
  styles: {
    global: {
      a: {
        textDecoration: "underline",
      },
    },
  },
});

export const queryClient = new QueryClient(); // eslint-disable-line

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ChakraProvider theme={theme}>
        <RouterProvider router={router} />
      </ChakraProvider>
    </QueryClientProvider>
  );
}

export default App;
